import React from 'react';

const ScrollMenu = () => {
  return (
    <div className="flex flex-col justify-center items-center text-center p-3 md:p-5 animate-fadein w-full border-2 rounded-lg border-dknavy ">
      <div className="w-full overflow-x-auto p-2 ">
        <div className="min-w-max inline-flex items-center space-x-6 text-navy font-display font-semi text-xl md:text-2xl md:pb-3">
          <a href="/projects" className="shrink-0">
            Featured
          </a>
          <a href="/in-progress" className="shrink-0">
            In Progress
          </a>
          <a href="/future-work" className="shrink-0">
            Future Work
          </a>
          <a href="/portfolio" className="shrink-0">
            Completed
          </a>
        </div>
      </div>
    </div>
  );
};

export default ScrollMenu;
